module.exports = __webpack_public_path__ + "img/shrewd-save-7.b377f84b.webp";